// extracted by mini-css-extract-plugin
module.exports = {"navigation":"style_navigation__cNu7S","navigation__wrapper":"style_navigation__wrapper___RVeS"};